import React, { useState } from "react";
import { useShowAlert } from "../../../context/AlertContext";
import { Tooltip } from "@mui/material";

const CopyBarcodeText = ({
  text
}) => {
  const showAlert = useShowAlert();
  const [hover, setHover] = useState(false);

  const handleCopy = async (barcode) => {
    try {
      await navigator.clipboard.writeText(barcode);
      showAlert("success", "Barcode copied successfully.");
    } catch (error) {
      console.error("Failed to copy barcode:", error);
      showAlert("error", "Failed to copy barcode.");
    }
  };

  return (
    <>
     <Tooltip title="Copy Barcode" arrow>
      <i
       className={`bx bx-copy cursor-pointer ${hover ? "text-primary" : "text-secondary"} ms-1`}    
        onClick={() => handleCopy(text)}
         onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{      
          marginTop:"2px",
          transition: "all 0.2s ease",
          cursor: "pointer",
        }}
      />
      </Tooltip>
    </>
  );
};

export default CopyBarcodeText;
